import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum,AppAction} from 'qcc'
import api, {AppFormResult} from 'api'

const sexOptions = [{label:'男',value:'1'},{label:'女',value:'2'}]

export default class UserModifyPasswordEdit extends React.PureComponent<AppFormPageProps> {
    state = {}
    

    save = async (formData:any) =>{
        if(formData.passwordNew !== formData.passwordConfirm){
            return {result:false,msg:'两次输入的密码不一致！'} as AppFormResult
        }
        await api.appuser.changePassword({userId:formData.id,password:formData.passwordNew})
        return {result:true} as AppFormResult
    }

    afterSave = () =>{
        AppAction.closeDialog();
    }
    
	render() {
		let {formData,mode} = this.props;
		return (<AppFormLayout defaultButton>
            <AppFormLayout.Form>
            <AppForm loadingData={false} 
                save = {this.save}
                mode={mode} 
                formData={formData} 
                afterSave={()=>{this.afterSave()}}>
                    <AppForm.Section labelWidth={100}>
                        <AppForm.Item field='name'  label="用户名称" readonly unSave />
                        <AppForm.Item field='account' label="账号" readonly unSave/>
						<AppForm.Item field='passwordNew' password itemType={AppFormItemEnum.input} placeholder='请输入新密码' label="新密码" unSave req/>
                        <AppForm.Item field='passwordConfirm' password itemType={AppFormItemEnum.input} placeholder='请再次输入新密码' label="确认密码" unSave req/>
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/application/user/UserModifyPasswordEdit.tsx